<template>
  <div
    v-if="appStore.isMobileScreen"
    class="sub-filter sticky top-0 z-navbarCategories bg-white pl-2 pr-3.5 sm:px-0"
    :class="searchKeyword ? 'py-2' : 'py-3'"
  >
    <div class="container mx-auto flex items-center">
      <categories-selector v-if="categoryId && !searchKeyword" />
      <mobile-search-button
        v-show="categoryId && !searchKeyword"
        v-model="isDrawerActive"
        v-model:keyword="searchKeyword"
        class="ml-auto"
        :search-input-placeholder="searchInputPlaceholder"
        @search="handleSearch"
      />
    </div>
    <mobile-search-input
      v-show="!categoryId || searchKeyword"
      v-model="isDrawerActive"
      :search-keyword="searchKeyword"
      @search="handleInputSearch"
      @clear="handleSearchClear"
    />
  </div>
</template>

<script lang="ts" setup>
import CategoriesSelector from '@/components/common/categories-selector.vue'
import MobileSearchButton from '@/components/search/mobile-search-button.vue'
import MobileSearchInput from '@/components/search/filter/mobile-search-input.vue'

import { useAppStore } from '@/store/app'
import { SearchType } from '@/types/search'

const appStore = useAppStore()

const { categoryId } = useCategory()
const { searchKeyword, searchInputPlaceholder, handleSearch } = useSearchInput()

const isDrawerActive = ref(false)

function handleInputSearch(keyword: string) {
  searchKeyword.value = keyword
  handleSearch({ text: keyword, type: SearchType.KEYWORD })
}

function handleSearchClear() {
  searchKeyword.value = ''
}
</script>
